"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.VerifyAccountProvider = exports.VerifyAccountConsumer = void 0;
var lodash_get_1 = __importDefault(require("lodash.get"));
var React = __importStar(require("react"));
var App_1 = require("../App");
var enums_1 = require("../Common/utils/enums");
var VerifyAccountContext = React.createContext({});
exports.VerifyAccountConsumer = VerifyAccountContext.Consumer;
exports.VerifyAccountProvider = function (_a) {
    var blockChannelSwitch = _a.blockChannelSwitch, channel = _a.channel, mfaState = _a.mfaState, override = _a.override, children = _a.children, setChannel = _a.setChannel, setMfaState = _a.setMfaState;
    var state = React.useContext(App_1.RiskContext).state;
    var overrideId = override && override.id;
    var overrideType = override && override.type;
    var mfaDetail = lodash_get_1["default"](state, 'challengePayload.mfaDetail') || {};
    var userDetail = (state.challenge === enums_1.RiskActions.PhoneEmailVerify &&
        lodash_get_1["default"](state, 'challengePayload.userDetail')) ||
        undefined;
    return (React.createElement(VerifyAccountContext.Provider, { value: {
            blockChannelSwitch: blockChannelSwitch,
            channel: channel,
            mfaDetail: mfaDetail,
            mfaState: mfaState,
            overrideId: overrideId,
            overrideType: overrideType,
            setChannel: setChannel,
            setMfaState: setMfaState,
            userDetail: userDetail
        } }, children));
};
exports["default"] = VerifyAccountContext;
